import React from 'react';
import styled from 'styled-components';

export const Table = styled.table`
  width: 90%;
  margin: 0 auto 20px auto;
`;

export const Thead = styled.thead``;

export const Tbody = styled.tbody``;

export const Row = styled.tr`
  colour: #292D34;
  font-size: 18px;
  padding 20px 0;
  border: 1px solid #dddddd;
`;

export const HeadingCell = styled.th
  .attrs(props => ({
    colSpan: props.colSpan,
    rowSpan: props.rowSpan
  }))<{ colSpan?: any; rowSpan?: any; centered?: boolean; }>`
  vertical-align: middle;
  height: 40px;
  font-size: 16px;
  text-align: left;
  padding: 8px 10px;
  text-align: ${props => props.centered? 'center' : 'left'};
`;

export const Cell = styled.td
  .attrs(props => ({
    colSpan: props.colSpan,
    rowSpan: props.rowSpan
  }))<{ colSpan?: any; rowSpan?: any; centered?: boolean; }>`
  vertical-align: middle;
  padding: 8px 10px;
  font-size: 14px;
  text-align: ${props => props.centered? 'center' : 'left'};
`;